<template>
  <div class="about-page">
    <section class="about-hero">
      <span class="label">About</span>
      <h1 class="page-title">FireX Fire Protection</h1>
      <p class="about-hero-text">
        Full-service fire protection for the High Desert and all of California.
      </p>
    </section>

    <section class="about-main">
      <div class="about-grid">
        <div class="about-content">
          <h2 class="content-heading">
            Smart Decisions for Your<br />Family &amp; Business
          </h2>
          <p>
            FireX understands the demands placed on business owners and managers
            to maintain compliance and protect their employees, customers, and
            property. Our goal is to offer a tailored program for each customer's
            unique challenges.
          </p>
          <p>
            As a full-service fire protection company, FireX can address all your
            fire protection needs. We take pride in knowing our systems offer the
            maximum level of safety and effectiveness. Through our experienced
            and licensed personnel, we offer 24-hour, 365-day service to fit
            your needs.
          </p>
          <p>
            We are located in Yucca Valley, California and provide fire
            protection and life safety services throughout the state.
          </p>
        </div>
        <div class="about-visual">
          <img class="about-image" src="../assets/img/circle.svg" alt="Fire protection tools" />
        </div>
      </div>
    </section>

    <section class="highlights">
      <div class="highlights-grid">
        <div class="highlight-card">
          <div class="highlight-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <h3>Expert Members</h3>
          <p>Our team has decades of hands-on experience in fire protection systems across California.</p>
        </div>
        <div class="highlight-card">
          <div class="highlight-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <h3>Licensed Specialty</h3>
          <p>C-16 Fire Protection Contractor License #1141817. E License #5063.</p>
        </div>
        <div class="highlight-card">
          <div class="highlight-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
          </div>
          <h3>Quality Products</h3>
          <p>We offer the highest quality certified products from trusted distributors like Amerex, Viking, and more.</p>
        </div>
      </div>
    </section>

    <section class="licenses">
      <span class="label">Credentials</span>
      <h2 class="section-heading">Licenses &amp; Certifications</h2>
      <div class="license-content">
        <div class="license-image-wrapper">
          <img src="../assets/license.jpg" alt="FireX Inc. — C-16 Lic# 1141817, E. Lic# 5063" class="license-image" />
        </div>
        <div class="license-cards">
          <div class="license-card">
            <div class="license-type">C-16</div>
            <div class="license-name">Fire Protection Contractor</div>
            <div class="license-number">License #1141817</div>
          </div>
          <div class="license-card">
            <div class="license-type">E</div>
            <div class="license-name">Fire Extinguisher License</div>
            <div class="license-number">License #5063</div>
          </div>
        </div>
      </div>
    </section>

    <section class="team-section">
      <span class="label">Team</span>
      <h2 class="section-heading">The People Behind FireX</h2>
      <div class="team-grid">
        <div class="team-card">
          <img class="team-photo" src="../assets/img/member1.png" alt="Team member" />
          <div class="team-info">
            <h3>FireGuy</h3>
            <p>CFO</p>
          </div>
        </div>
        <div class="team-card">
          <img class="team-photo" src="../assets/img/member2.png" alt="Team member" />
          <div class="team-info">
            <h3>Zac</h3>
            <p>CEO</p>
          </div>
        </div>
        <div class="team-card">
          <img class="team-photo" src="../assets/img/member3.png" alt="Team member" />
          <div class="team-info">
            <h3>Other Zac</h3>
            <p>Project Manager</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.about-page {
  padding-bottom: 0;
}

.label {
  display: block;
  font-family: var(--font-display);
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--color-fire);
  margin-bottom: 1.5rem;
}

.page-title {
  font-family: var(--font-display);
  font-size: clamp(2rem, 5vw, 3rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 0.75rem;
}

.about-hero {
  padding: 5rem clamp(2rem, 8vw, 8rem) 3rem;
}

.about-hero-text {
  max-width: 500px;
  color: var(--color-text-muted);
  font-size: 1rem;
  line-height: 1.7;
}

.section-heading {
  font-family: var(--font-display);
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  letter-spacing: -0.02em;
  margin-bottom: 2rem;
}

/* ── MAIN ── */
.about-main {
  padding: 3rem clamp(2rem, 8vw, 8rem) 5rem;
  max-width: 1100px;
}

.about-grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 4rem;
  align-items: center;
}

.content-heading {
  font-family: var(--font-display);
  font-size: 1.75rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.about-content p {
  color: var(--color-text-muted);
  line-height: 1.8;
  margin-bottom: 1rem;
  font-size: 0.95rem;
}

.about-image {
  max-width: 100%;
  opacity: 0.8;
}

@media (max-width: 768px) {
  .about-grid {
    grid-template-columns: 1fr;
  }
  .about-visual {
    display: none;
  }
}

/* ── HIGHLIGHTS ── */
.highlights {
  padding: 4rem 2rem;
  background: var(--color-surface);
}

.highlights-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  max-width: 1100px;
  margin: 0 auto;
}

.highlight-card {
  padding: 2rem;
}

.highlight-icon {
  color: var(--color-fire);
  margin-bottom: 1.25rem;
}

.highlight-card h3 {
  font-family: var(--font-display);
  font-size: 1.15rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.highlight-card p {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  line-height: 1.7;
}

/* ── LICENSES ── */
.licenses {
  padding: 5rem clamp(2rem, 8vw, 8rem);
}

.license-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
}

.license-image-wrapper {
  flex-shrink: 0;
}

.license-image {
  max-width: 320px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid var(--color-border);
}

.license-cards {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.license-card {
  background: var(--color-bg);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  padding: 1.5rem 2rem;
  min-width: 220px;
}

.license-type {
  font-family: var(--font-display);
  font-size: 2.5rem;
  font-weight: 800;
  color: var(--color-fire);
  margin-bottom: 0.25rem;
}

.license-name {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

.license-number {
  font-size: 0.8rem;
  color: var(--color-text-muted);
}

/* ── TEAM ── */
.team-section {
  padding: 5rem 2rem;
  background: var(--color-surface);
}

.team-grid {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  max-width: 900px;
  margin: 0 auto;
}

.team-card {
  text-align: center;
}

.team-photo {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid var(--color-border);
  margin-bottom: 1rem;
}

.team-info h3 {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 600;
}

.team-info p {
  font-size: 0.85rem;
  color: var(--color-fire);
  font-weight: 500;
  margin-top: 0.25rem;
}
</style>
